import { FormattedMessage, injectIntl } from 'react-intl'
import React, { PureComponent } from 'react'
import Modal from 'src/components/Modal/Modal'
import SvgIcon from 'src/components/SvgIcon'

import styles from './styles.module.less'
import { isIos, isInStandaloneMode, getBodyContainer, getIconFromGraphics } from 'src/utils/helpers'
import intlMessagesApp from 'src/modules/App/translations'

class AddToHomeScreen extends PureComponent {
  state = {
    visible: false,
  }

  componentDidMount() {
    const { isAddToHomeScreenClosed } = this.props

    if (isIos() && !isInStandaloneMode() && !isAddToHomeScreenClosed) {
      setTimeout(() => this.setState({ visible: true }), 4000)
    }
  }

  closeModal = () => {
    const { afterAddToHomeScreenClose } = this.props

    this.setState(
      {
        visible: false,
      },
      () => {
        if (afterAddToHomeScreenClose && typeof afterAddToHomeScreenClose === 'function') {
          afterAddToHomeScreenClose()
        }
      },
    )
  }

  renderConfirmationContent = () => {
    const { graphics, brand, intl } = this.props

    const brandColor = brand && brand.hasOwnProperty('brandColor') ? brand.brandColor : null
    const icon = getIconFromGraphics(graphics, 'apple-touch-icon')
    return (
      <>
        <div className={styles.pwaModalContent}>
          <div className={styles.iconClose} onClick={this.closeModal}>
            <SvgIcon size='md' type='RemoveThinner' />
          </div>
          <div className={styles.iconContainer}>
            <div className={styles.iconBlank} />
            <div className={styles.iconBlank} />
            <div
              className={styles.iconKiosk}
              style={brandColor ? { backgroundColor: brandColor } : {}}
            >
              <img
                // eslint-disable-next-line react/no-unknown-property
                display-if={icon}
                src={icon}
                alt={intl.formatMessage(intlMessagesApp.altIconKiosk)}
              />
            </div>
            <div className={styles.iconBlank} />
            <div className={styles.iconBlank} />
          </div>
          <h2>
            <FormattedMessage
              id='app.addToHomeScreen.install'
              description='Install <brend app name>'
              defaultMessage='Install'
            />
            &nbsp;{brand.name || ''}
          </h2>
          <p>
            <FormattedMessage
              id='app.addToHomeScreen.installDescription'
              defaultMessage="Install this application on your home screen for quick and easy access when you're on the go."
            />
          </p>
        </div>
        <div className={styles.pwaModalFooter}>
          <FormattedMessage
            id='app.addToHomeScreen.installDescription2'
            description='Part of a message `Just tap share <icon> then add to home screen'
            defaultMessage='Just tap'
          />
          <SvgIcon type='ShareAddToHomeScreen' className={styles.pwaModalShareIcon} />
          <FormattedMessage
            id='app.addToHomeScreen.installDescription3'
            description='Part of a message `Just tap share <icon> then add to home screen'
            defaultMessage="then 'Add to Home Screen'"
          />
        </div>
      </>
    )
  }

  render() {
    const { visible } = this.state

    return (
      <Modal
        isOpen={visible}
        isCentered
        className={styles.pwaModal}
        closable={false}
        footer={null}
        onOk={this.submitModal}
        onCancel={this.closeModal}
        renderContent={this.renderConfirmationContent}
        getContainer={() => getBodyContainer()}
        hideFooter={true}
        hideTitle={true}
      ></Modal>
    )
  }
}

export default injectIntl(AddToHomeScreen)
